import { ArrowRightIcon } from "@cpj-ai/panel-npm-package";
import { Button } from "@heroui/react";
import React from "react";

interface NavigationButtonsProps {
  onPrevious: () => void;
  onNext: () => void;
}

const NavigationButtons: React.FC<NavigationButtonsProps> = ({ onPrevious, onNext }) => {
  return (
    <div className="flex gap-4 justify-end">
      <Button
        isIconOnly
        size="sm"
        radius="md"
        variant="bordered"
        onPress={onPrevious}
        className="pb-2 border-zinc-600"
        aria-label="Previous dates"
      >
        <ArrowRightIcon className="w-7 h-7 rotate-180 stroke-zinc-600" />
      </Button>
      <Button
        isIconOnly
        size="sm"
        radius="md"
        variant="bordered"
        onPress={onNext}
        className="pb-2 border-zinc-600"
        aria-label="Next dates"
      >
        <ArrowRightIcon className="w-7 h-7 mt-3.5 stroke-zinc-600" />
      </Button>
    </div>
  );
};

export default NavigationButtons;
